import React from 'react';
import PropTypes from 'prop-types';

import { bars as Bars } from '@breezeway/brzw-components';

import {
  refactorData,
  renderAssignmentBarLabel,
  newCountAssignmentsData,
} from '../../utils/assignment_bar';

const AssignmentBar = ({ personTaskAssignmentStats, personAvailability }) => {
  const data = newCountAssignmentsData(refactorData(personAvailability), personTaskAssignmentStats);

  return (
    <Bars.AvailabilityBar
      subtitle={renderAssignmentBarLabel(personTaskAssignmentStats)}
      title="T:"
      withHourLabels={false}
      data={data}
    />
  );
};

AssignmentBar.propTypes = {
  personTaskAssignmentStats: PropTypes.shape(),
  personAvailability: PropTypes.arrayOf(PropTypes.shape()),
};

export default AssignmentBar;
